import React, { useEffect } from "react";
import { useParams } from "react-router";
import OrderMain from "../Order";
import { removeUpdateOrderLastEditBy } from "api/order";
import { safeError } from "utils/logger";

const DuplicateOrder = () => {
  const { id } = useParams();

  useEffect(() => {
    return () => {
      let postData = {
        orderId: id,
      };
      removeUpdateOrderLastEditBy(postData)
        .then((data) => {
        })
        .catch((err) => {
          safeError("removeUpdateOrderLastEditBy error", err);
        });
    };
  }, []);

  return <OrderMain module="edit-order" title="Edit Order" />;
};

export default DuplicateOrder;
